import React from 'react';
import PropTypes from 'prop-types';
import States from './States';
import Countries from './Countries';
import Label from '../Label';

export default class ContactForm extends React.Component {
    // TODO: Validation/etc
    render() {
        let stateInput = (
            <input
                id="state"
                name="state"
                type="text"
                className="rec-required"
                value={this.props.account.home_address.state || ''}
                onChange={this.props.handleChange} />
        );
        if (this.props.account.home_address.country === 'USA') {
            stateInput = <States account={this.props.account} className="rec-required" handleChange={this.props.handleChange} />
        }


        let button = (
            <button
                className="rec-button-primary"
                onClick={this.props.verifyAddress}>
                Verify Address
            </button>
        );
        if ( this.props.account.home_address.country !== 'USA'){
            button = (
            <button
                className="rec-button-primary"
                onClick={this.props.saveProfile}>
                Save
            </button>);
        }

        return (
            <div>
                <div className="rec-verify-contact-row">
                    <div className="rec-form-item-wrap">
                        <Label htmlFor="first_name" isRequired>First Name</Label>
                        <input
                            id="first_name"
                            name="first_name"
                            type="text"
                            className="rec-required"
                            value={this.props.account.first_name || ''}
                            onChange={this.props.handleChange} />
                    </div>
                    <div className="rec-form-item-wrap">
                        <Label htmlFor="last_name" isRequired>Last Name</Label>
                        <input
                            id="last_name"
                            name="last_name"
                            type="text"
                            className="rec-required"
                            value={this.props.account.last_name || ''}
                            onChange={this.props.handleChange} />
                    </div>
                </div>
                <div className="rec-verify-contact-row">
                    <div className="rec-form-item-wrap">
                        <Label htmlFor="country" isRequired>Country</Label>
                        <Countries account={this.props.account} className="rec-required" handleChange={this.props.handleChange} />
                    </div>
                </div>
                <div className="rec-verify-contact-row">
                    <div className="rec-form-item-wrap">
                        <label htmlFor="address1">Address Line 1*</label>
                        <input
                            id="address1"
                            name="address1"
                            type="text"
                            className="rec-required"
                            value={this.props.account.home_address.address1 || ''}
                            onChange={this.props.handleChange} />
                    </div>
                    <div className="rec-form-item-wrap">
                        <label htmlFor="address2">Address Line 2</label>
                        <input
                            id="address2"
                            name="address2"
                            type="text"
                            className=""
                            value={this.props.account.home_address.address2 || ''}
                            onChange={this.props.handleChange} />
                    </div>
                </div>
                <div className="rec-verify-contact-row">
                    <div className="rec-form-item-wrap">
                        <label htmlFor="city">City*</label>
                        <input
                            id="city"
                            name="city"
                            type="text"
                            className="rec-required"
                            value={this.props.account.home_address.city || ''}
                            onChange={this.props.handleChange} />
                    </div>
                </div>
                <div className="rec-verify-contact-row">
                    <div className="rec-form-item-wrap">
                        <label htmlFor="state">State/Province*</label>
                        {stateInput}
                    </div>
                    <div className="rec-form-item-wrap">
                        <label htmlFor="zip_code">ZIP/Postal Code*</label>
                        <input
                            id="zip_code"
                            name="zip_code"
                            type="text"
                            className="rec-required"
                            value={this.props.account.home_address.zip_code || ''}
                            onChange={this.props.handleChange} />
                    </div>
                </div>
                <div className="rec-verify-contact-footer">
                    {button}
                </div>
            </div>
        );
    }
}

ContactForm.propTypes = {
    account: PropTypes.shape({
        account_id: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string
    }).isRequired,
    handleChange: PropTypes.func.isRequired,
    verifyAddress: PropTypes.func.isRequired,
    saveProfile: PropTypes.func.isRequired
};
